import React, { FC } from 'react'

// Styles
import { Backdrop, Dialog, DialogContent, DialogProps, Theme, makeStyles } from '@material-ui/core'

export const Modal: FC<DialogProps> = ({ open, onClose, children }) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll='body'
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 1000 }}
    >
      <DialogContent classes={{ root: classes.content }}>{children}</DialogContent>
    </Dialog>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    outline: '0',
    '& *': { outline: '0' }
  }
}))
